import { render } from "./RuletaActivacion.vue?vue&type=template&id=0764952c&scoped=true"
import script from "./RuletaActivacion.vue?vue&type=script&lang=js"
export * from "./RuletaActivacion.vue?vue&type=script&lang=js"

import "./RuletaActivacion.vue?vue&type=style&index=0&id=0764952c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0764952c"]])

export default __exports__